module.exports = __webpack_public_path__ + "img/10.fac17bb1.jpg";